export enum GlucoseUnit {
  MilligramsPerDeciliter = "mg/dL",
  MillimolesPerLiter = "mmol/L",
}
